import { useEffect } from 'react';

export function useElementDurations(
  enabled: boolean,
  tracks: Array<{ role: string; url: string }>,
  refs: any,
  setDuration: (n: number) => void,
) {
  useEffect(() => {
    if (enabled) return;
    const durs: Record<string, number> = {};
    for (const t of tracks) {
      const el = refs.elsRef.current[t.role];
      const d = el?.duration;
      durs[t.role] = (typeof d === 'number' && isFinite(d) && d > 0) ? d : 0;
    }
    const vals = Object.values(durs).filter(v => v > 0);
    setDuration(vals.length ? Math.max(...vals) : 0);
  }, [enabled, tracks]);
}
